import axios from "axios";
const AD_token = 'eyJ0eXAiOiJKV1QiLCJub25jZSI6IlVoaXpfcmlLNnY3dzRLVl9RaHdRODVzS0h5T3ZPclZTZDRtQk0yVmcwSFEiLCJhbGciOiJSUzI1NiIsIng1dCI6IlhSdmtvOFA3QTNVYVdTblU3Yk05blQwTWpoQSIsImtpZCI6IlhSdmtvOFA3QTNVYVdTblU3Yk05blQwTWpoQSJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC82MjJmOGNkZS0wN2I1LTRkMTYtYWIyYS02ZGMwYzNhNjZlMzUvIiwiaWF0IjoxNzA5MTg4MjMyLCJuYmYiOjE3MDkxODgyMzIsImV4cCI6MTcwOTE5MzMzOSwiYWNjdCI6MCwiYWNyIjoiMSIsImFpbyI6IkFUUUF5LzhXQUFBQStOQjkzM3luWGdOMXp3TWNNeE5iNi9pTGNUSjNKSXhuNkZaQ1dGYXE5eXZLV0pIejd3TnA3RFA1VTcvQWlXckoiLCJhbXIiOlsicHdkIl0sImFwcF9kaXNwbGF5bmFtZSI6IkdyYXBoIEV4cGxvcmVyIiwiYXBwaWQiOiJkZThiYzhiNS1kOWY5LTQ4YjEtYThhZC1iNzQ4ZGE3MjUwNjQiLCJhcHBpZGFjciI6IjAiLCJjYXBvbGlkc19sYXRlYmluZCI6WyIyNGIyNmVhOC04N2QwLTQ1MWItYmJhNy04MjE4YzcyYTViNWMiXSwiZGV2aWNlaWQiOiJlYjVhN2ZkNC04N2RjLTRkN2UtYTEwMS1mMDZhMWY5NTE3MmIiLCJmYW1pbHlfbmFtZSI6Ikt1bWFyIiwiZ2l2ZW5fbmFtZSI6IlN1bmlsIiwiaWR0eXAiOiJ1c2VyIiwiaXBhZGRyIjoiMTY1LjIyNS4xMjAuOTciLCJuYW1lIjoiU3VuaWwgS3VtYXIiLCJvaWQiOiI1MzczNGExZS1hMDZhLTRjYzYtYTVhMC1kYjkxNzA5OGFhMDYiLCJvbnByZW1fc2lkIjoiUy0xLTUtMjEtMTc1Nzk4MTI2Ni0xOTU3OTk0NDg4LTE4MDE2NzQ1MzEtNDQ4MzY1IiwicGxhdGYiOiIzIiwicHVpZCI6IjEwMDMyMDAxREFFMjRBRjEiLCJyaCI6IjAuQVQ0QTNvd3ZZclVIRmsyckttM0F3Nlp1TlFNQUFBQUFBQUFBd0FBQUFBQUFBQUEtQUd3LiIsInNjcCI6IkFwcGxpY2F0aW9uLlJlYWQuQWxsIEFwcGxpY2F0aW9uLlJlYWRXcml0ZS5BbGwgb3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIGVtYWlsIiwic2lnbmluX3N0YXRlIjpbImR2Y19tbmdkIiwiZHZjX2NtcCIsImR2Y19kbWpkIl0sInN1YiI6IkRvaDFJN1NrcXh5dVhhdG90dm9iOC1WekkwU2JpaFYwU1hzTi1kQkdxMEEiLCJ0ZW5hbnRfcmVnaW9uX3Njb3BlIjoiQVMiLCJ0aWQiOiI2MjJmOGNkZS0wN2I1LTRkMTYtYWIyYS02ZGMwYzNhNjZlMzUiLCJ1bmlxdWVfbmFtZSI6IjQ3MjgzQGl0Y2luZm90ZWNoLmNvbSIsInVwbiI6IjQ3MjgzQGl0Y2luZm90ZWNoLmNvbSIsInV0aSI6Ii04cjJjYi1BYlU2NVNOVlVHM0pWQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfY2MiOlsiQ1AxIl0sInhtc19zc20iOiIxIiwieG1zX3N0Ijp7InN1YiI6InBVeHJMdmVWV2NpUGpadjlvU0xpTTF3dWhZdHVuZlNzS3ZVbUNfVzRKQkUifSwieG1zX3RjZHQiOjEzMDM4MTIzOTh9.ZTIZp2wQoJArRNgG6MqfKQN_a132GFKQpn_liimGOTp5TfVj66OdUiSHx03ZUG7K5peCzVGdh6KYSBVTLIF0mWcepjwJegUbdh3hHNE40LrP6SMUmCgmvygcW_LmLQlM6ALOeQCEwrwYW_P1QX-Zj_WbLIIDQyixUtT3tHE4trBC2Jj6YdH5o5Df598OQNESXYD4ug_FFRayFr-lMCq5vl69JUEm2jJAg_s9ilcTCcv24slHtRriX6myf39hz_zZMrmo7wWHce428Pg49foretfYJBVzz4PkigCIEK7YWdYNH4UtOTphzLW3tWdTXjPK6fxIcUj62BLaL3uNDrwjLQ'

let baseURL = process.env.REACT_APP_API_ENDPOINT

const branch = process.env.REACT_APP_BRANCH




if (branch) {
  if(branch != '/v1'){
    baseURL += branch
  }
} else {
  baseURL = baseURL
}


export const  http = axios.create({
baseURL:baseURL,
   headers: {
    "Content-type": "application/json",
    "access-control-allow-origin":"*",
  },

});

export const  httpAD = axios.create({
  baseURL: "https://graph.microsoft.com/v1.0",
  headers: {
    "Content-type": "application/json",
    Authorization: `Bearer ${AD_token}`
  }
});
export const  httpPOC = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    "Content-type": "application/json",
    // Authorization: `Bearer ${AD_token}`
  }
});

//comment

